export class SoTopFiveDetails{
    
    variantCode: string;
    count: string;
    invoiceDate: string;
    actEdlDate: string;
  
}